import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import { colorBlack, colorTeal } from '../../../utils/variables.scss';
import { formatDate } from '../../../utils/helpers';
import Button from '../../../components/Button';
import ButtonAction from '../../../components/ButtonAction';
import InfoIcon from '../../../components/icons/Info';
import MultiColoredStarIcon from '../../../components/icons/MultiColoredStar';
import Default, { Mobile } from '../../../utils/mediaQueries';
import { withRtl } from '../../../components/hoc';
import messages from '../../../locale/messages';
import style from './Program.scss'; // eslint-disable-line css-modules/no-unused-class
import { MT_AUDITION_PROGRAMS } from '../../../constants';
import {customisedIntlFormatMessage} from '../../../utils/helpers';

/* eslint-disable css-modules/no-undef-class */
const localMessages = defineMessages({
  scheduleDeadlinePassed: {
    id: 'schedule.ScheduleDeadlinePassed',
    defaultMessage: 'The Schedule Deadline Has Passed',
    description: 'Message shown when the schedule deadline has passed',
  },
  programNoSchedule: {
    id: 'schedule.ProgramNoSchedule',
    defaultMessage: 'Program Cannot Currently be Scheduled',
    description: 'Message shown when a program cannot be scheduled',
  },
  compositeNoSchedule: {
    id: 'schedule.CompositeNoSchedule',
    defaultMessage: '{type} Cannot Currently be Scheduled',
    description: 'Message shown when a composite program cannot be scheduled',
  },
  buttonReScheduleCancelAcademicTestWithDescription: {
    id: 'schedule.buttonReScheduleCancelWithProgramSchoolDescription',
    defaultMessage: 'Reschedule (or cancel) Specialized High School Admissions Test',
    description: 'Reschedule or cancel Specialized High School Admissions Test',
  },
  buttonScheduleAppointmentForAcademicTestWithProgramDescription: {
    id: 'schedule.buttonScheduleAppointmentWithProgramSchoolDescription',
    defaultMessage: 'Schedule Specialized High School Admissions Test',
    description: 'Schedule appointment for Specialized High School Admissions Test',
  },
  buttonUnExpressInterestForAcademicTestWithProgramDescription: {
    id: 'schedule.buttonUnExpressInterestWithProgramSchoolDescription',
    defaultMessage: 'Un-Express interest for Specialized High School Admissions Test',
    description: 'Un-Express interest for Specialized High School Admissions Test',
  },
  buttonExpressInterestForAcademicTestWithProgramDescription: {
    id: 'schedule.buttonExpressInterestWithProgramSchoolDescription',
    defaultMessage: 'Express interest for Specialized High School Admissions Test',
    description: 'Express interest for Specialized High School Admissions Test',
  },
  buttonCancelRegistrationForAcademicTestWithProgramDescription: {
    id: 'schedule.buttonCancelRegistrationWithProgramSchoolDescription',
    defaultMessage: 'Cancel registration for Specialized High School Academic Test',
    description: 'Cancel registration for Specialized High School Academic Test',
  },
  shsScheduleDefaultLabel: {
    id: 'schedule.shsScheduleDefaultLabel',
    defaultMessage: 'Schedule the Specialized High School Admissions Test',
    description: 'Default label for the shs test',
  },
  gtScheduleDefaultLabel: {
    id: 'schedule.gtScheduleDefaultLabel',
    defaultMessage: 'Schedule the Gifted and Talented Test',
    description: 'Default label for the G&T exam',
  },
  msAdmissionMethod: {
    id: 'schedule.msAdmissionMethod',
    defaultMessage: 'Talent test',
    description: 'Admission method for the middle school application',
  },
  auditionProgramInfoText: {
    id: 'schedule.auditionProgramInfoText',
    defaultMessage: 'To be considered for this program, express your interest, upload the required materials, and add it to your application.',
    description: 'To be considered for this program, express your interest, upload the required materials, and add it to your application.',
  },
});

class Program extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
    };
  }

  toggleProgram = () => {
    this.setState({ show: !this.state.show });
  };

  renderScheduleButton = () => {
    const { program, initScheduling, intl, removeNoMatchingTimeSlot, isMS } = this.props;

    if (program.schedule && program.schedule.deadline_passed) {
      return (
        <div>
          <FormattedMessage {...localMessages.scheduleDeadlinePassed} />
        </div>
      );
    }

    // const buttonClasses = classNames('button--no-style', style.scheduleProgramScheduleButton);

    let label;
    let ariaLabelValue;
    const hasNoMatchingTimeSlot = program.schedule && program.schedule.no_matching_time_slot;

    if (program.appointment) {
      label = customisedIntlFormatMessage(intl, messages.buttonReScheduleCancel);
      ariaLabelValue = localMessages.buttonReScheduleCancelAcademicTestWithDescription;
    } else if (program.schedule) {
      label = customisedIntlFormatMessage(intl, messages.buttonScheduleAppointment);
      ariaLabelValue = localMessages.buttonScheduleAppointmentForAcademicTestWithProgramDescription;
      if (isMS) {
        if (program.schedule.expression_of_interest.id) {
          if(MT_AUDITION_PROGRAMS.includes(program.schedule.name)){
            label = program.schedule.post_submission_button_name;
            ariaLabelValue = localMessages.buttonUnExpressInterestForAcademicTestWithProgramDescription;
          }
          else{
            label = program.schedule.post_submission_button_name;
            ariaLabelValue = localMessages.buttonUnExpressInterestForAcademicTestWithProgramDescription;
          }
        } else if (program.schedule.express_interest) {
          if(MT_AUDITION_PROGRAMS.includes(program.schedule.name)){
            label = program.schedule.pre_submission_button_name;
            ariaLabelValue = localMessages.buttonExpressInterestForAcademicTestWithProgramDescription;
          }
          else{
            label = program.schedule.pre_submission_button_name;
            ariaLabelValue = localMessages.buttonExpressInterestForAcademicTestWithProgramDescription;
          }
        }
      } else if (program.schedule.expression_of_interest.id) {
        label = customisedIntlFormatMessage(intl, messages.buttonUnExpressInterest);
        ariaLabelValue = localMessages.buttonUnExpressInterestForAcademicTestWithProgramDescription;
      } else if (program.schedule.express_interest) {
        label = 'Schedule Appointment';
        ariaLabelValue = localMessages.buttonExpressInterestForAcademicTestWithProgramDescription;
      } else if (program.schedule.no_matching_time_slot) {
        label = customisedIntlFormatMessage(intl, messages.buttonCancelRegistration);
        ariaLabelValue = localMessages.buttonCancelRegistrationForAcademicTestWithProgramDescription;
      }
    }
    const ariaLabel = customisedIntlFormatMessage(intl, ariaLabelValue, {
      programTitle: program.name,
      schoolName: program.school.name,
    });

    if (label) {
      return (
        <div>
          <Default>
            <ButtonAction
              icon="Calendar-Outline"
              large
              onClick={
                hasNoMatchingTimeSlot
                  ? () => removeNoMatchingTimeSlot(program.schedule.no_matching_time_slot.id)
                  : () => initScheduling(program)
              }
              label={label}
            />
          </Default>
          <Mobile>
            <Button
              label={label}
              ariaLabel={ariaLabel}
              iconLeft="Calendar-Outline"
              onClick={
                hasNoMatchingTimeSlot
                  ? () => removeNoMatchingTimeSlot(program.schedule.no_matching_time_slot.id)
                  : () => initScheduling(program)
              }
              iconColor={colorTeal}
            />
          </Mobile>
        </div>
      );
    }

    return (
      <div>
        {program.composite ? (
          <FormattedMessage
            {...localMessages.compositeNoSchedule}
            values={{ type: customisedIntlFormatMessage(intl, messages.generalStringTest) }}
          />
        ) : (
          <FormattedMessage {...localMessages.programNoSchedule} />
        )}
      </div>
    );
  };

  renderScheduleInfo = () => {
    const { program, intl } = this.props;

    return (
      <div className={style.scheduleProgramScheduleContainer}>
        <div className={style.scheduleProgramSchedule}>
          <div className={style.scheduleProgramScheduleInfoContainer}>
            <div className={style.scheduleProgramAdmissionMethodContainer}>
              <div className={style.scheduleProgramScheduleInfoTitle}>
                <FormattedMessage {...messages.generalStringAdmissionMethod} />
              </div>
              <div>{program.admission_method && program.admission_method.name}</div>
            </div>
            <div className={style.scheduleProgramDeadlineContainer}>
              <div className={style.scheduleProgramScheduleInfoTitle}>
                <FormattedMessage {...messages.generalStringScheduleDeadline} />
              </div>
              <div>{program.schedule ? formatDate(program.schedule.deadline, intl) : '-'}</div>
            </div>
          </div>
          {program.composite ? (
            undefined
          ) : (
            <div className={style.scheduleProgramScheduleButtonContainer}>{this.renderScheduleButton()}</div>
          )}
        </div>
      </div>
    );
  };

  renderSharedScheduleInfo = () => {
    const { program, intl } = this.props;

    return (
      <div className={style.specializedBottom}>
        <div className={style.specializedAdmissionDetails}>
          <FormattedMessage {...messages.generalStringAdmissionMethod} />
          <div>{program.admission_method && program.admission_method.name}</div>
        </div>
        <div className={style.specializedAdmissionDetails}>
          <FormattedMessage {...messages.generalStringScheduleDeadline} />
          <div>{program.schedule ? formatDate(program.schedule.deadline, intl) : '-'}</div>
        </div>
      </div>
    );
  };

  render() {
    const { program, isSHS, isGT, isMS, intl } = this.props;
    const { show } = this.state;
    const showDetails = show && !isSHS && !isGT && !isMS;

    return (
      <div className={style.scheduleProgram}>
        <div className={style.scheduleProgramTop}>
          <div className={style.scheduleProgramSchoolContainer}>
            {/* <button className={classNames('button--no-style', style.scheduleProgramSchool)} onClick={() => {}}>
              {program.school.name} <i className="icon-Caret-Down" />
            </button> */}
            <h2 className={style.scheduleProgramHeading}>{program.school.name}</h2>
            {program.composite ? (
              <div className={style.scheduleProgramScheduleButtonContainer}>{this.renderScheduleButton()}</div>
            ) : (
              <div>
                <div className={style.scheduleProgramSchoolInfo}>
                  <span>
                    <i className="icon-Subway" /> 2.1mi
                  </span>
                  <span>
                    <i className="icon-Preferences" /> 5 of 9
                  </span>
                  <span>
                    <i className="icon-Mortarboard" /> K-12
                  </span>
                  <span>
                    <i className="icon-Accessibility" /> {program.school.accessibility}
                  </span>
                </div>
                {isSHS && (
                  <div
                    className={classNames(
                      style.scheduleProgramScheduleButtonContainer,
                      style.scheduleProgramScheduleButtonContainerShs,
                    )}
                  >
                    {this.renderScheduleButton()}
                  </div>
                )}
              </div>
            )}
          </div>
          {MT_AUDITION_PROGRAMS.includes(program.schedule.name) && (
            <div className={style.scheduleProgramAuditionProgramsInfo}>{customisedIntlFormatMessage(intl, localMessages.auditionProgramInfoText)}</div>)}
        </div>
        {showDetails && (
          <div className={style.scheduleProgramBottom}>
            <div className={style.scheduleProgramBottomRow}>
              <div
                className={classNames(
                  style.scheduleProgramBottomBlock,
                  style.scheduleProgramBottomBlockLeft,
                )}
              />
              <div
                className={classNames(
                  style.scheduleProgramBottomBlock,
                  style.scheduleProgramBottomBlockMiddle,
                )}
              >
                <MultiColoredStarIcon size="22px" />
              </div>
              <div
                className={classNames(
                  style.scheduleProgramBottomBlock,
                  style.scheduleProgramBottomBlockRight,
                )}
              >
                <div className={style.scheduleProgramNameContainer}>
                  <div className={style.scheduleProgramName}>{program.name}</div>
                  <div className={style.scheduleProgramNameIcon}>
                    <InfoIcon border={colorBlack} fill="#4DB6F7" size="20" />
                  </div>
                </div>
                <Default>{this.renderScheduleInfo()}</Default>
              </div>
            </div>
            <Mobile>
              <div className={style.scheduleProgramBottomRow}>{this.renderScheduleInfo()}</div>
            </Mobile>
          </div>
        )}
        {show && (isSHS || isGT || isMS) && this.renderSharedScheduleInfo()}
      </div>
    );
  }
}

Program.defaultProps = {
  isRtl: false,
};

Program.propTypes = {
  program: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  isRtl: PropTypes.bool,
  initScheduling: PropTypes.func.isRequired,
  removeNoMatchingTimeSlot: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.shape({}),
    formatMessage: PropTypes.func,
  }).isRequired,
  isSHS: PropTypes.bool.isRequired,
  isGT: PropTypes.bool.isRequired,
  isMS: PropTypes.bool.isRequired,
};

export default withRtl(style)(injectIntl(withStyles(style)(Program)));

const CompositeProgramCard = props => {
  const { schedule, initScheduling, isSHS, isRtl, removeNoMatchingTimeSlot, isGT, intl, isMS } = props;
  let name = '';
  if (isGT) {
    name = customisedIntlFormatMessage(intl, localMessages.gtScheduleDefaultLabel);
  } else if (isSHS) {
    name = customisedIntlFormatMessage(intl, localMessages.shsScheduleDefaultLabel);
  } else if (isMS) {
    name = schedule && schedule.name;
  }
  const program = {
    appointment: schedule && schedule.appointment,
    schedule,
    expression_of_interest: true, // schedule && schedule.expression_of_interest,
    admission_method: {
      name: isMS ? customisedIntlFormatMessage(intl, localMessages.msAdmissionMethod) : customisedIntlFormatMessage(intl, messages.generalStringTest),
    },
    school: {
      accessibility: 'Fully Accessible',
      name,
    },
    composite: true,
  };
  return (
    <div>
      <Program
        program={program}
        initScheduling={initScheduling}
        intl={props.intl}
        isSHS={isSHS}
        isGT={isGT}
        isMS={isMS}
        isRtl={isRtl}
        removeNoMatchingTimeSlot={removeNoMatchingTimeSlot}
      />
    </div>
  );
};

CompositeProgramCard.propTypes = {
  schedule: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  initScheduling: PropTypes.func.isRequired,
  removeNoMatchingTimeSlot: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired,
  isSHS: PropTypes.bool.isRequired,
  isMS: PropTypes.bool.isRequired,
  isGT: PropTypes.bool.isRequired,
  isRtl: PropTypes.bool.isRequired,
};

const WrappedCompositeProgramCard = withRtl(style)(injectIntl(withStyles(style)(CompositeProgramCard)));

export { WrappedCompositeProgramCard as CompositeProgramCard };
